import { CLAIMS } from '@libs/authentication/claims';
import { INavigationConfig } from '@libs/layout';

export const MENU: INavigationConfig[] = [
  {
    route: '/recruiting',
    label: 'Recruiting',
    enabled: true,
  },
  {
    route: '/business',
    label: 'Business',
    enabled: true,
  },
  {
    route: '/profile',
    align: 'right',
    label: 'Profile',
    enabled: true,
  },
];
